import React, { useContext, useState } from 'react';
import { cookieExist, setCookie } from '../browser-cookies';
import { AppContext } from '../../Store';
import { TermsCheckboxContext } from '../../state-management/contexts/regform-checkboxes/terms-checkbox-context';
import { COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE } from '../cookie-overlay';
import { useTranslation } from 'react-i18next';
import { registerWithOneClick } from '../form-registrations';

export const withOneClickValidation = function(Component) {
	const EnhancedComponent = function({ ...props }) {
		const [state, dispatch] = useContext(AppContext);
		const [termsState, termsDispatch] = useContext(TermsCheckboxContext);
		const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
		const { t } = useTranslation('translation');

		const handlePlayClick = async (e) => {
			e ? e.preventDefault() : null;

			setShowLoadingIndicator(true);

			if (!termsState.value) {
				termsDispatch({ type: 'SET_TC_ERROR', payload: t('form.terms.errorMessages.errorMessageEmpty') });
				termsDispatch({ type: 'SHOW_TC_ERROR' });

				setShowLoadingIndicator(false);
			}

			if (
				termsState.value &&
				!termsState.error.message
			) {
				termsDispatch({ type: 'HIDE_TC_ERROR' });

				if (!cookieExist(COOKIE_NOTIFICATION_NAME)) {
					setCookie(COOKIE_NOTIFICATION_NAME, COOKIE_NOTIFICATION_VALUE_REJECT, COOKIE_NOTIFICATION_EXPIRATION_DATE);
					dispatch({ type: 'HIDE_COOKIE_OVERLAY' });
					dispatch({ type: 'MARK_TRACKING_EXECUTED' });
				}

				await registerWithOneClick(
					state.locale,
					dispatch,
					termsDispatch,
					termsState.value,
					state.thirdPartyTrackingAccepted,
				);
			}
			else {
				setShowLoadingIndicator(false);
			}
		};

		return (
			<Component
				{...props}
				handlePlayClick={handlePlayClick}
				showLoadingIndicator={showLoadingIndicator}
			/>
		);
	};
	EnhancedComponent.displayName = 'componentWithValidation';
	return EnhancedComponent;
};
